module.exports = __webpack_public_path__ + "img/list.10d088c2.svg";